(function () {
  const blocks = document.querySelectorAll('.about-story-block');
  if (!blocks.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  blocks.forEach(function (block) {
    observer.observe(block);
  });
})();
